import { AnalyticsHelperService } from './../../services/analytics-helper.service';
import { AnalyticsService } from '@app/shared/modules/analytics/services/analytics.service';
import { ProductsStoreService } from './../../stores/products-store.service';
import { ChargingStationPricing } from '../../libs/feature-lib/charging-station/charging-station-pricing.service';
import { map, mergeMap } from 'rxjs/operators';
import { EvsbProductOverviewMapper } from './evsb-product-overview.mapper';
import { EvsbProductOverviewModel } from './evsb-product-overview.model';
import { Observable, combineLatest } from 'rxjs';
import { Injectable } from '@angular/core';
import { SmallBizStoreService } from '../../stores/small-biz-store.service';

@Injectable()
export class EvsbProductOverviewService {
  constructor(
    private mapper: EvsbProductOverviewMapper,
    private store: SmallBizStoreService,
    private chargingStationPricing: ChargingStationPricing,
    private productsStoreService: ProductsStoreService,
    private analyticsService: AnalyticsService,
    private analyticsHelperService: AnalyticsHelperService
  ) {}

  public getModel$(): Observable<EvsbProductOverviewModel> {
    return this.store.model$.pipe(
      mergeMap((model) =>
        combineLatest([
          this.productsStoreService.card$.pipe(map((card) => parseInt(card.price, 10))),
          this.chargingStationPricing.mininumPrice$(),
          this.chargingStationPricing.for$(model.chargingStationConfig),
          this.chargingStationPricing.breakdownFor$(model.chargingStationConfig),
        ]).pipe(
          map(([cardPrice, minCharginStationPrice, charginStationPrice, chargingStationBreakdown]) =>
            this.mapper.map({
              storeModel: model,
              cardPrice,
              charginStationPrice,
              minCharginStationPrice,
              chargingStationBreakdown,
            })
          )
        )
      )
    );
  }

  public analyticsEmpty() {
    this.analyticsHelperService.analyticsWorkflowStep('overview/empty');
  }

  public analyticsProductAdded() {
    this.analyticsHelperService.analyticsWorkflowStep('overview/product-added');
  }

  public analyticsCta(action: string, solution: string) {
    this.analyticsService.push({
      event: 'cta',
      eventCategory: 'b-to-b-ev-simulator',
      eventAction: action,
      eventLabel: solution,
    });
  }

  public analyticsGreenEnergyPopup() {
    this.analyticsService.push({
      event: 'popup',
      eventCategory: 'b-to-b-ev-simulator',
      eventAction: 'open-fiscality-popup',
    });
  }
}
